import { z } from 'zod';
import { SemverSchema } from './version.js';

export const PanelReleaseSchema = z.object({
  version: SemverSchema,
  notes: z.string(),
  current: z.boolean(),
  security: z.boolean(),
});
export const PanelReleasesSchema = PanelReleaseSchema.array();
export type PanelRelease = z.infer<typeof PanelReleaseSchema>;
